import { createFileRoute } from "@tanstack/react-router"
import { PublicRoute } from "@/content"

export const Route = createFileRoute("/(public)")({
  ssr: true,
  component: RouteComponent,
})

function RouteComponent() {
  return <PublicRoute />
}
